import {NativeApi, OS} from "@/modules/NativeBridge";
import {GeoAvailability, geoGranted, geoNotPrompted} from "@/store/modules/geo";
import {JLocation, RegReminderConfig, NotificationManagerStatus, BackgroundLocationPermission} from "@/modules/models";
import {AbortableDelay} from "@/modules/delay";

export class MockNativeBridge implements NativeApi {

    locations: JLocation[] = [];
    locationsIdx = 0;
    abortableDelay = new AbortableDelay();
    nextLocation: JLocation | null = null;
    geoAvailability = geoNotPrompted;

    constructor() {
        this.locations = [
            new JLocation(61.439922, 5.850366, 1554907994245),
            new JLocation(61.450491, 5.855104, 1554908235301),
            new JLocation(61.450500, 5.855114, 1554908235351),
        ];
    }

    readonly available: boolean = true;
    readonly versionString: string = "0.1.1";
    readonly os: OS = OS.Android;

    atleastVersion(major: number, minor: number, patch: number): boolean {
        return true;
    }

    firstTest(txt: string): Promise<number> {
        return Promise.resolve(8899);
    }

    async geoCheckAvailability(): Promise<GeoAvailability> {
        return Promise.resolve(this.geoAvailability);
    }

    async geoNext(current: JLocation | null, timeoutSeconds: number, minDiffMeters: number): Promise<JLocation | null> {
        this.geoAvailability = geoGranted;
        const waitTime = this.locationsIdx < this.locations.length ? (this.locationsIdx * 10) + 4 : 400;
        if (this.locationsIdx >= this.locations.length) {
            this.locationsIdx = 0;
        }
        this.nextLocation = this.locations[this.locationsIdx++];
        console.debug(`waiting ${waitTime} seconds for next position update that is at least ${minDiffMeters} meters away from current..`);
        await this.abortableDelay.delay(waitTime * 1000, false);
        return this.nextLocation;
    }

    geoStop(): Promise<void> {
        this.nextLocation = null;
        this.abortableDelay.abort();
        return Promise.resolve();
    }

    setRpcAuthtoken(token: string): Promise<void> {
        console.debug(`RpcAuthtoken should now be set to ${token} in app.`);
        return Promise.resolve();
    }

    setServerConfiguration(selectedConfiguration: number): Promise<void> {
        return Promise.resolve();
    }

    async getRegReminderConfig(): Promise<RegReminderConfig> {
        return Promise.resolve(RegReminderConfig.default());
    }
    async setRegReminderConfig(c: RegReminderConfig): Promise<RegReminderConfig> {
        return Promise.resolve(c);
    }

    async fixLocationSettings(): Promise<boolean> {
        return Promise.resolve(false);
    }

    async getQrcode(): Promise<string|null> {
        return null;
    }

    async getNotificationManagerStatus(): Promise<NotificationManagerStatus> {
        return new NotificationManagerStatus(true, new Map<string, boolean>()); // Default value
    }

    async openNotificationSettings(): Promise<void> {
        return;
    }

    async requestReview(): Promise<boolean> {
        return false;
    }

    async openAppSettings(): Promise<boolean> {
        return false;
    }

    async checkBackgroundLocationPermission(): Promise<BackgroundLocationPermission> {
        return new BackgroundLocationPermission(false, 2);
    }

}